import React from 'react';
import cn from 'classnames';

export type ExclamationMarkProps = {
	rounded?: boolean;
	className?: string;
};

export function ExclamationMark({rounded = false, className}: ExclamationMarkProps): React.ReactElement {
	return (
		<span
			className={cn('flex h-14 w-14 flex-none items-center justify-center bg-[#FD927C] text-[#121212]', className, {
				'rounded-full': rounded,
			})}
			aria-hidden="true"
		>
			<svg width="3" height="18" viewBox="0 0 3 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="2.5" height="13" fill="black" />
				<rect y="15" width="2.5" height="3" fill="black" />
			</svg>
		</span>
	);
}
